<template>
	<div>
		<v-alert :value="showAlert" type="info" class="alert ml-4 mr-4 mb-3">
			Data wystawienia {{ documentNumbers.length > 1 ? 'dokumentów' : 'dokumentu' }}
			{{documentNumbers.join(", ")}}
			wykracza poza okres realizacji projektu.
		</v-alert>
		<v-alert :value="showDonationAndInvoiceDateMismatchAlert" type="info" class="alert ml-4 mr-4 mb-3">
			Data wystawienia {{ donationOutOfInvoiceDateRangeDocumentNumbers.length > 1 ? 'dokumentów' : 'dokumentu' }}
			{{donationOutOfInvoiceDateRangeDocumentNumbers.join(", ")}}
			wykracza poza termin wykorzystania dotacji.
		</v-alert>
		<v-alert :value="showDonationAndPaymentDateMismatchAlert" type="info" class="alert ml-4 mr-4 mb-3">
			Data płatności {{ donationOutOfPaymentDateRangeDocumentNumbers.length > 1 ? 'dokumentów' : 'dokumentu' }}
			{{donationOutOfPaymentDateRangeDocumentNumbers.join(", ")}}
			wykracza poza termin wykorzystania dotacji.
		</v-alert>
		<v-alert :value="showContributionAndInvoiceDateMismatchAlert" type="info" class="alert ml-4 mr-4 mb-3">
			Data wystawienia {{ contributionOutOfInvoiceDateRangeDocumentNumbers.length > 1 ? 'dokumentów' : 'dokumentu' }}
			{{contributionOutOfInvoiceDateRangeDocumentNumbers.join(", ")}}
			wykracza poza termin wykorzystania wkładu własnego.
		</v-alert>
		<v-alert :value="showContributionAndPaymentDateMismatchAlert" type="info" class="alert ml-4 mr-4 mb-3">
			Data płatności {{ contributionOutOfPaymentDateRangeDocumentNumbers.length > 1 ? 'dokumentów' : 'dokumentu' }}
			{{contributionOutOfPaymentDateRangeDocumentNumbers.join(", ")}}
			wykracza poza termin wykorzystania wkładu własnego.
		</v-alert>
		<v-alert :value="showPaymentDateTooEarlyAlert" type="info" class="alert ml-4 mr-4 mb-3">
			Data płatności {{ paymentDateOutOfRangeDocumentNumbers.length > 1 ? 'dokumentów' : 'dokumentu' }}
			{{paymentDateOutOfRangeDocumentNumbers.join(", ")}} jest wcześniejsza niż data wystawienia.
		</v-alert>
	</div>
</template>

<script>
	import {Dates} from "@/utils/Dates";

	export default {
		name: "ProjectInvoicesDateMismatchWarning",

		mixins: [Dates],

		data () {
			return {
				documentNumbers: [],
        donationOutOfInvoiceDateRangeDocumentNumbers: [],
        donationOutOfPaymentDateRangeDocumentNumbers: [],
        contributionOutOfInvoiceDateRangeDocumentNumbers: [],
        contributionOutOfPaymentDateRangeDocumentNumbers: [],
        paymentDateOutOfRangeDocumentNumbers: [],
				dataPrepared: false
			};
		},

		mounted () {
			this.documentNumbers = [];
			this.invoices.forEach(invoice => {
				let formattedInvoiceDate = invoice.documentDate.split("-").reverse().join("-");
        let formattedPaymentDate = invoice.paymentDates[0] ? invoice.paymentDates[0].split("-").reverse().join("-") : null;
				if (formattedInvoiceDate < this.projectStartDate || formattedInvoiceDate > this.projectEndDate) {
          this.documentNumbers.push(invoice.documentNumber);
        }
        if ((this.terms.donationFrom && (formattedInvoiceDate < this.terms.donationFrom))
            || (this.terms.donationTo && (formattedInvoiceDate > this.terms.donationTo))) {
          this.donationOutOfInvoiceDateRangeDocumentNumbers.push(invoice.documentNumber);
        }
        if ((this.terms.donationFrom && formattedPaymentDate && (formattedPaymentDate < this.terms.donationFrom))
            || (this.terms.donationTo && formattedPaymentDate && (formattedPaymentDate > this.terms.donationTo))) {
          this.donationOutOfPaymentDateRangeDocumentNumbers.push(invoice.documentNumber);
        }
        if ((this.terms.contributionFrom && (formattedInvoiceDate < this.terms.contributionFrom))
            || (this.terms.contributionTo && (formattedInvoiceDate > this.terms.contributionTo))) {
          this.contributionOutOfInvoiceDateRangeDocumentNumbers.push(invoice.documentNumber);
        }
        if ((this.terms.contributionFrom && formattedPaymentDate && (formattedPaymentDate < this.terms.contributionFrom))
            || (this.terms.contributionTo && formattedPaymentDate && (formattedPaymentDate > this.terms.contributionTo))) {
          this.contributionOutOfPaymentDateRangeDocumentNumbers.push(invoice.documentNumber);
        }
        if (formattedPaymentDate && formattedInvoiceDate > formattedPaymentDate) {
          this.paymentDateOutOfRangeDocumentNumbers.push(invoice.documentNumber);
        }
			});
			this.dataPrepared = true;
		},

		computed: {
			showAlert () {
				return this.projectStartDate && this.projectEndDate && this.documentNumbers.length > 0 && this.dataPrepared;
			},

      showDonationAndInvoiceDateMismatchAlert () {
        return this.donationOutOfInvoiceDateRangeDocumentNumbers.length > 0 && this.dataPrepared;
      },

      showDonationAndPaymentDateMismatchAlert() {
        return this.donationOutOfPaymentDateRangeDocumentNumbers.length > 0 && this.dataPrepared;
      },

      showContributionAndInvoiceDateMismatchAlert () {
        return this.contributionOutOfInvoiceDateRangeDocumentNumbers.length > 0 && this.dataPrepared;
      },

      showContributionAndPaymentDateMismatchAlert() {
        return this.contributionOutOfPaymentDateRangeDocumentNumbers.length > 0 && this.dataPrepared;
      },

      showPaymentDateTooEarlyAlert () {
        return this.paymentDateOutOfRangeDocumentNumbers.length > 0 && this.dataPrepared;
      }
		},

		props: {
			projectStartDate: null,
			projectEndDate: null,
			invoices: {
				type: Array,
				required: true
			},
      terms: {default: {}}
		}
	};
</script>

<style scoped>
@media print {
	.alert {
		background-color: lightgrey !important;
		color: black;
		border: none;
	}
	.alert >>> .v-icon {
		display: none;
	}
}
</style>
